import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { GripVertical } from 'lucide-react';

// Generic drag-to-reorder list used by the Experiences and Booking Rigs admin
// pages. `items` is an ordered array; `onReorder` fires with the new array order.
// `getLabel` returns the row title; `getBadge` (optional) returns a trailing badge.
export default function ReorderableList({ items, onReorder, getLabel, getBadge }) {
  const handleDragEnd = (res) => {
    if (!res.destination || res.destination.index === res.source.index) return;
    const next = Array.from(items);
    const [moved] = next.splice(res.source.index, 1);
    next.splice(res.destination.index, 0, moved);
    onReorder(next);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="reorderable-list">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="space-y-2">
            {items.map((it, i) => {
              const id = String(it.id || it.key || i);
              return (
                <Draggable key={id} draggableId={id} index={i}>
                  {(p, s) => (
                    <div
                      ref={p.innerRef}
                      {...p.draggableProps}
                      {...p.dragHandleProps}
                      className={`flex items-center gap-3 bg-[#111115] border px-4 py-3 transition-colors ${s.isDragging ? 'border-primary shadow-lg' : 'border-white/5'}`}
                    >
                      <GripVertical className="w-4 h-4 text-white/30 shrink-0" />
                      <span className="text-white/30 text-xs font-bold w-6">{i + 1}</span>
                      <span className="text-white font-bold text-sm uppercase truncate flex-1">{getLabel(it)}</span>
                      {getBadge && getBadge(it)}
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}